import en from './locale/en.json';
import es from './locale/es.json';
import fr from './locale/fr.json';
import pt_BR from './locale/pt_BR.json';

export default {
  en,
  es,
  fr,
  pt_BR,
};
